import React, { useState, useEffect, useRef, useCallback } from 'react';

function CheckboxDropdown({ name, options = [], value, onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const selected = Array.isArray(value) ? value.filter(v => v !== '전체') : [];
  const isAllSelected = selected.length === 0;
  const displayText = isAllSelected
    ? '전체'
    : selected
        .map(v => { const opt = options.find(o => o.value === v); return opt ? opt.label : v; })
        .join(', ');

  const handleOptionChange = useCallback((optionValue) => {
    if (optionValue === '전체') {
      onChange(name, []);
      return;
    }
    const next = selected.includes(optionValue)
      ? selected.filter(v => v !== optionValue)
      : [...selected, optionValue];
    onChange(name, next);
  }, [name, onChange, selected]);

  const isChecked = (optionValue) => {
    if (optionValue === '전체') return isAllSelected;
    return selected.includes(optionValue);
  };

  return (
    <div className="checkbox-dropdown" ref={ref}>
      <button
        type="button"
        className={`checkbox-dropdown-trigger${isOpen ? ' open' : ''}`}
        onClick={() => setIsOpen(prev => !prev)}
      >
        <span>{displayText}</span>
        <span className="checkbox-dropdown-arrow">{isOpen ? '▴' : '▾'}</span>
      </button>
      {isOpen && (
        <div className="checkbox-dropdown-menu">
          {options.map((option) => (
            <label key={option.value} className="checkbox-dropdown-item">
              <input
                type="checkbox"
                checked={isChecked(option.value)}
                onChange={() => handleOptionChange(option.value)}
              />
              <span>{option.label}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}

export default React.memo(CheckboxDropdown);
